import { apiRequest } from "../util/apiUtils";

export const getmediaList = async (params) => {
  try {
    const res = await apiRequest("get", `/media/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const multipleMediaAdd = async (payload) => {
  try {
    const res = await apiRequest(
      "post",
      `/media/store-media`,
      {
        body: payload,
      }

      // "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const mediaEdit = async (payload) => {
  try {
    const res = await apiRequest(
      "put",
      `/media/edit-media`,
      {
        body: payload,
      }
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const fetchBatchImages = async (batchId) => {
  try {
    const res = await apiRequest("get", "/media/batch-wise-list", {
      queries: { batchId },
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const fetchBatchImagesByBookId = async (bookId) => {
  try {
    const res = await apiRequest("get", "/media/batch-wise-list", {
      queries: { bookId },
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
